export default "__VITE_ASSET__FIkmJhaO__"